// EXPERIMENT: psf_featured_spiking_petition_experiment — remove with experiment cleanup
import { localStorage } from '@change-corgi/core/storage';

const STORAGE_KEY = 'psf/featured_spiking_petition/exposed_at';
const CAP_DAYS = 7;
const MS_PER_DAY = 86_400_000;

/** Whether the browser recorded an exposure in the last `CAP_DAYS` days. Callers must have `preferences` consent. */
export function wasExposedRecently(now: Date): boolean {
	try {
		const exposedAt = Date.parse(localStorage.getItem(STORAGE_KEY) ?? '');
		return Number.isFinite(exposedAt) && now.getTime() - exposedAt < CAP_DAYS * MS_PER_DAY;
	} catch {
		return false;
	}
}

/** Callers must have `preferences` consent. */
export function recordExposure(now: Date): void {
	try {
		localStorage.setItem(STORAGE_KEY, now.toISOString());
	} catch {
		// Storage full or blocked: the signer can be exposed again on a later visit, the same in every arm.
	}
}
